var React = require('react');

function LockWhite (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#fff","d":"M96 192V128C96 57.31 153.3 0 224 0C294.7 0 352 57.31 352 128V192H384C419.3 192 448 220.7 448 256V448C448 483.3 419.3 512 384 512H64C28.65 512 0 483.3 0 448V256C0 220.7 28.65 192 64 192H96zM144 192H304V128C304 83.82 268.2 48 224 48C179.8 48 144 83.82 144 128V192zM48 448C48 456.8 55.16 464 64 464H384C392.8 464 400 456.8 400 448V256C400 247.2 392.8 240 384 240H64C55.16 240 48 247.2 48 256V448z"}));
}

LockWhite.defaultProps = {"viewBox":"0 0 448 512"};

module.exports = LockWhite;

LockWhite.default = LockWhite;
